import React from 'react';
import { Trash2 } from 'lucide-react';
import type { PollTiming } from './types';
import type { TimeUnit } from '../../types';

interface PollTimingInputProps {
  expiresAt?: string;
  onChange: (expiresAt?: string) => void;
}

export function PollTimingInput({ expiresAt, onChange }: PollTimingInputProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Expires At (optional)
        </label>
      </div>
      <div className="flex gap-2 items-center">
        <input
          type="datetime-local"
          value={expiresAt ? new Date(expiresAt).toLocaleString('sv-SE').slice(0, 16) : ''}
          onChange={(e) => onChange(e.target.value ? new Date(e.target.value).toISOString() : undefined)}
          min={new Date().toLocaleString('sv-SE').slice(0, 16)}
          className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
        />
        {expiresAt && (
          <button
            onClick={() => onChange(undefined)}
            className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            title="Clear expiration date"
          >
            <Trash2 className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
}